import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { TablePagination, TableRow } from '@mui/material';
import TableCell from 'src/components/Table/TableCell';
import { useTranslation } from 'react-i18next';
import TablePaginationCustom from 'src/components/Table/TablePaginationCustom';
import Table from 'src/components/Table';
import CFDIIncomeRow from './CFDIIncomeRow';

if (!process.env.REACT_APP_TABLE_SIZE) {
  console.error(
    'REACT_APP_TABLE_SIZE variable not loaded properly. Check your .env file please!'
  );
}

const Tbody = ({ cfdis }) =>
  cfdis.map(cfdi => <CFDIIncomeRow key={cfdi.id} {...cfdi} />);

const CFDIIncomeTable = ({
  className,
  cfdis,
  count,
  page,
  handleChangePage,
  loading,
  ...rest
}) => {
  const { t } = useTranslation();

  const theads = useMemo(() => () => (
    <TableRow component="tr">
      <TableCell style={{ width: '14%' }} align="center">
        {t('COMMON.DATE')}
      </TableCell>
      <TableCell style={{ width: '12%' }} align="center">
        {t('CFDI_VIEWS.RENTS')}
      </TableCell>
      <TableCell style={{ width: '12%' }} align="center">
        {t('CFDI_VIEWS.INITIAL_PAYMENT')}
      </TableCell>
      <TableCell style={{ width: '12%' }} align="center">
        {t('CFDI_VIEWS.CAPITAL_CONTRIBUTIONS')}
      </TableCell>
      <TableCell style={{ width: '12%' }} align="center">
        {t('CFDI_VIEWS.EQUIPMENT_SALES')}
      </TableCell>
      <TableCell style={{ width: '12%' }} align="center">
        {t('CFDI_VIEWS.DEFAULT_INTERESTS')}
      </TableCell>
      <TableCell style={{ width: '12%' }} align="center">
        {t('CFDI_VIEWS.INCOME_OTHERS')}
      </TableCell>
      <TableCell style={{ width: '12%' }} align="center">
        {t('CFDI_VIEWS.INCOME_TOTAL')}
      </TableCell>
    </TableRow>
  ));

  const tbody = useMemo(() => () => <Tbody cfdis={cfdis} />, [cfdis]);

  const pagination = useMemo(
    () => () => (
      <TablePagination
        rowsPerPageOptions={[]}
        component="div"
        count={count}
        rowsPerPage={+process.env.REACT_APP_TABLE_SIZE}
        page={page}
        onPageChange={handleChangePage}
        ActionsComponent={TablePaginationCustom}
        labelDisplayedRows={({ from, to, count: c }) => {
          return `${from}-${to} ${t('COMMON.OF')} ${c}`;
        }}
      />
    ),
    [page, cfdis]
  );

  return (
    <Table
      {...rest}
      tbody={tbody}
      theads={theads}
      pagination={pagination}
      loading={loading}
    />
  );
};

CFDIIncomeTable.propTypes = {
  className: PropTypes.string,
  cfdis: PropTypes.array.isRequired,
  count: PropTypes.number,
  page: PropTypes.number,
  handleChangePage: PropTypes.func,
  loading: PropTypes.bool
};

CFDIIncomeTable.defaultProps = {
  count: 0
};

export default CFDIIncomeTable;
